(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dibbs-quick-view"] && !Shopify.designMode) return;
  try {
    (() => {
  const initializeDibbsQuickView = () => {
    const dialog = document.getElementById('db-quick-view-dialog');
    if (!dialog || dialog.dataset.dbBound === 'true') return;
    dialog.dataset.dbBound = 'true';

    const mainImage = dialog.querySelector('[data-db-quick-main]');
    const thumbs = dialog.querySelector('[data-db-quick-thumbs]');
    const title = dialog.querySelector('[data-db-quick-title]');
    const price = dialog.querySelector('[data-db-quick-price]');
    const options = dialog.querySelector('[data-db-quick-options]');
    const quantity = dialog.querySelector('[data-db-quick-quantity]');
    const addButton = dialog.querySelector('[data-db-quick-add]');
    const fullLink = dialog.querySelector('[data-db-quick-full]');
    const status = dialog.querySelector('[data-db-quick-status]');
    let currentProduct = null;
    let currentTrigger = null;

    const labels = {
      add: dialog.dataset.labelAddToBag || 'Add to bag',
      unavailable: dialog.dataset.labelUnavailable || 'Unavailable',
      loading: dialog.dataset.labelLoading || 'Loading…',
      adding: dialog.dataset.labelAdding || 'Adding to bag…',
      added: dialog.dataset.labelAdded || 'Added to bag',
      error: dialog.dataset.labelError || 'Something went wrong. Please try again.'
    };

    const formatPrice = (cents) => '₹' + Math.round(Number(cents || 0) / 100).toLocaleString('en-IN');
    const variantValues = (variant) => Array.isArray(variant.options)
      ? variant.options
      : [variant.option1, variant.option2, variant.option3].filter((value) => value !== null && value !== undefined);

    const findVariant = () => {
      if (!currentProduct || !currentProduct.variants?.length) return null;
      const selects = Array.from(options.querySelectorAll('select'));
      if (!selects.length) return currentProduct.variants.find((variant) => variant.available !== false) || currentProduct.variants[0];
      return currentProduct.variants.find((variant) => {
        const values = variantValues(variant);
        return selects.every((select, index) => values[index] === select.value);
      }) || null;
    };

    const updateVariantState = () => {
      const variant = findVariant();
      if (variant) price.textContent = formatPrice(variant.price);
      addButton.disabled = !variant || variant.available === false;
      addButton.textContent = variant && variant.available !== false
        ? labels.add
        : labels.unavailable;
      return variant;
    };

    const renderImages = (product, trigger) => {
      const imageUrls = (product.images || []).filter(Boolean);
      if (!imageUrls.length && trigger.dataset.dbQuickImage) imageUrls.push(trigger.dataset.dbQuickImage);
      if (imageUrls[0]) {
        mainImage.src = imageUrls[0];
        mainImage.alt = product.title || trigger.dataset.dbQuickTitle || '';
      }
      thumbs.replaceChildren();
      imageUrls.forEach((url, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', 'View image ' + (index + 1));
        button.setAttribute('aria-pressed', String(index === 0));
        const image = document.createElement('img');
        image.src = url;
        image.alt = '';
        button.append(image);
        button.addEventListener('click', () => {
          mainImage.src = url;
          thumbs.querySelectorAll('button').forEach((item) => item.setAttribute('aria-pressed', 'false'));
          button.setAttribute('aria-pressed', 'true');
        });
        thumbs.append(button);
      });
    };

    const renderOptions = (product) => {
      const optionNames = Array.isArray(product.options)
        ? product.options.map((option) => typeof option === 'string' ? option : option.name).filter(Boolean)
        : [];
      options.replaceChildren();
      optionNames.forEach((name, index) => {
        const values = [];
        (product.variants || []).forEach((variant) => {
          const value = variantValues(variant)[index];
          if (value && !values.includes(value)) values.push(value);
        });
        if (!values.length) return;
        const label = document.createElement('label');
        label.className = 'db-quick-view__option';
        const labelText = document.createElement('span');
        labelText.textContent = name;
        const select = document.createElement('select');
        select.setAttribute('aria-label', name);
        values.forEach((value) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = value;
          select.append(option);
        });
        select.addEventListener('change', updateVariantState);
        label.append(labelText, select);
        options.append(label);
      });
    };

    const renderProduct = (product, trigger) => {
      currentProduct = product;
      currentTrigger = trigger;
      title.textContent = product.title || trigger.dataset.dbQuickTitle || '';
      price.textContent = product.variants?.[0] ? formatPrice(product.variants[0].price) : trigger.dataset.dbQuickPrice || '';
      fullLink.href = trigger.dataset.dbProductUrl || '/products/' + product.handle;
      renderImages(product, trigger);
      renderOptions(product);
      status.textContent = '';
      updateVariantState();
    };

    const openQuickView = async (trigger) => {
      currentProduct = null;
      currentTrigger = trigger;
      title.textContent = trigger.dataset.dbQuickTitle || '';
      price.textContent = trigger.dataset.dbQuickPrice || '';
      fullLink.href = trigger.dataset.dbProductUrl || '#';
      mainImage.src = trigger.dataset.dbQuickImage || '';
      mainImage.alt = trigger.dataset.dbQuickTitle || '';
      options.replaceChildren();
      addButton.disabled = true;
      addButton.textContent = labels.loading;
      status.textContent = labels.loading;
      quantity.value = '1';
      if (!dialog.open) dialog.showModal();
      document.documentElement.style.overflow = 'hidden';

      try {
        const response = await fetch(trigger.dataset.dbQuickUrl, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Product details failed to load');
        renderProduct(await response.json(), trigger);
      } catch (error) {
        status.textContent = labels.error;
        addButton.disabled = true;
      }
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-db-quick-view]');
      if (!trigger) return;
      event.preventDefault();
      event.stopPropagation();
      openQuickView(trigger);
    });

    addButton.addEventListener('click', async () => {
      const variant = findVariant();
      const count = Math.max(1, parseInt(quantity.value, 10) || 1);
      if (!variant || variant.available === false) return;
      addButton.disabled = true;
      addButton.textContent = labels.adding;
      status.textContent = '';
      try {
        const response = await fetch(dialog.dataset.dbCartAddUrl, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: count }] })
        });
        if (!response.ok) throw new Error('Cart add failed');
        const cartResponse = await fetch(dialog.dataset.dbCartUrl, { headers: { Accept: 'application/json' } });
        const cart = await cartResponse.json();
        document.querySelectorAll('.db-bag-count').forEach((badge) => { badge.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
        status.textContent = labels.added;
      } catch (error) {
        status.textContent = labels.error;
      } finally {
        addButton.disabled = false;
        updateVariantState();
      }
    });

    dialog.querySelector('[data-db-quick-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = '';
      currentTrigger?.focus();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeDibbsQuickView, { once: true });
  } else {
    initializeDibbsQuickView();
  }
  document.addEventListener('shopify:section:load', initializeDibbsQuickView);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dibbs-ui"] && !Shopify.designMode) return;
  try {
    (() => {
  let lastTrigger;
  const init = () => {
    document.querySelectorAll('[data-db-picks]').forEach(section => {
      const viewport = section.querySelector('.db-picks-viewport');
      const track = section.querySelector('[data-db-picks-track]');
      const set = track?.querySelector('[data-db-picks-set]');
      if (!viewport || !track || !set || track.dataset.bound) return;
      const shuffleButton = section.querySelector('[data-db-picks-shuffle]');
      let dragState = null;
      let suppressClickUntil = 0;
      let wheelResumeTimer = 0;
      const cloneLoop = () => {
        track.querySelector('.db-picks-clone')?.remove();
        set.querySelectorAll('img').forEach(image => { image.draggable = false; });
        const clone = set.cloneNode(true);
        clone.querySelectorAll('img').forEach(image => { image.draggable = false; });
        clone.classList.add('db-picks-clone');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(element => element.setAttribute('tabindex', '-1'));
        track.append(clone);
        track.style.setProperty('--db-picks-duration', Math.max(48, set.scrollWidth / 85) + 's');
        track.classList.add('is-looping');
      };
      const shufflePicks = () => {
        const cards = Array.from(set.children);
        for (let i = cards.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [cards[i], cards[j]] = [cards[j], cards[i]];
        }
        cards.forEach(card => set.append(card));
        cloneLoop();
      };
      const getMarqueeAnimation = () => track.getAnimations().find(animation => animation.animationName === 'dibbs-top-picks');
      const beginDrag = event => {
        if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
        const animation = getMarqueeAnimation();
        animation?.pause();
        dragState = {
          pointerId: event.pointerId,
          startX: event.clientX,
          startTime: Number(animation?.currentTime ?? 0) || 0,
          startScroll: viewport.scrollLeft,
          animation,
          moved: false
        };
      };
      const moveDrag = event => {
        const state = dragState;
        if (!state || event.pointerId !== state.pointerId) return;
        const deltaX = event.clientX - state.startX;
        if (Math.abs(deltaX) > 5) {
          if (!state.moved) {
            state.moved = true;
            viewport.classList.add('is-dragging');
            viewport.setPointerCapture(event.pointerId);
          }
          event.preventDefault();
          if (state.animation) {
            const durationSeconds = parseFloat(getComputedStyle(track).animationDuration) || 90;
            const durationMs = durationSeconds * 1000;
            const width = Math.max(1, set.scrollWidth);
            const timeShift = deltaX / (width / durationSeconds) * 1000;
            state.animation.currentTime = ((state.startTime - timeShift) % durationMs + durationMs) % durationMs;
          } else {
            viewport.scrollLeft = state.startScroll - deltaX;
          }
        }
      };
      const endDrag = event => {
        const state = dragState;
        if (!state || event.pointerId !== state.pointerId) return;
        dragState = null;
        if (state.moved) {
          suppressClickUntil = performance.now() + 500;
          viewport.classList.remove('is-dragging');
          if (viewport.hasPointerCapture(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
        }
        state.animation?.play();
      };
      viewport.addEventListener('dragstart', event => event.preventDefault());
      viewport.addEventListener('pointerdown', beginDrag);
      viewport.addEventListener('pointermove', moveDrag, { passive: false });
      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);
      viewport.addEventListener('click', event => {
        if (event.detail !== 0 && performance.now() < suppressClickUntil) {
          event.preventDefault();
          event.stopPropagation();
          suppressClickUntil = 0;
        }
      }, true);
      const handleWheel = event => {
        if (event.deltaX === 0 && !event.shiftKey) return;
        const amount = event.shiftKey && event.deltaX === 0 ? event.deltaY : event.deltaX;
        if (!amount) return;
        const animation = getMarqueeAnimation();
        event.preventDefault();
        if (!animation) {
          viewport.scrollLeft += amount;
          return;
        }
        animation.pause();
        const durationSeconds = parseFloat(getComputedStyle(track).animationDuration) || 90;
        const durationMs = durationSeconds * 1000;
        const width = Math.max(1, set.scrollWidth);
        const timeShift = amount / (width / durationSeconds) * 1000;
        const currentTime = Number(animation.currentTime ?? 0) || 0;
        animation.currentTime = ((currentTime + timeShift) % durationMs + durationMs) % durationMs;
        window.clearTimeout(wheelResumeTimer);
        wheelResumeTimer = window.setTimeout(() => animation.play(), 180);
      };
      viewport.addEventListener('wheel', handleWheel, { passive: false });
      if (shuffleButton && !shuffleButton.dataset.bound) {
        shuffleButton.dataset.bound = 'true';
        shuffleButton.addEventListener('click', shufflePicks);
      }
      track.dataset.bound = 'true';
      shufflePicks();
    });
    document.querySelectorAll('[data-db-open]').forEach(button => {
      if(button.dataset.bound) return;
      button.dataset.bound='true';
      button.addEventListener('click', () => {
        const dialog=document.getElementById('db-piece-dialog');
        const dataNode=document.getElementById('db-catalog-data');
        if(!dialog || !dataNode) return;
        const product=JSON.parse(dataNode.textContent).find(p=>String(p.group)===button.dataset.dbOpen);
        if(!product) return;
        lastTrigger=button;
        dialog.querySelector('[data-db-title]').textContent=product.title;
        dialog.querySelector('[data-db-price]').textContent='₹'+Number(product.price_inr).toLocaleString('en-IN');
        dialog.querySelector('[data-db-size]').textContent=product.size;
        const main=dialog.querySelector('[data-db-main]');
        main.src=product.images[0]; main.alt=product.title;
        const thumbnails=dialog.querySelector('[data-db-thumbs]');thumbnails.replaceChildren();
        product.images.forEach((url,i)=>{
          const b=document.createElement('button');b.type='button';b.setAttribute('aria-label','View image '+(i+1));b.setAttribute('aria-pressed',String(i===0));
          const img=document.createElement('img');img.src=url;img.alt='';b.append(img);
          b.addEventListener('click',()=>{main.src=url;thumbnails.querySelectorAll('button').forEach(n=>n.setAttribute('aria-pressed','false'));b.setAttribute('aria-pressed','true');});thumbnails.append(b);
        });
        dialog.showModal();document.documentElement.style.overflow='hidden';
      });
    });
    const dialog=document.getElementById('db-piece-dialog');
    if(dialog&&!dialog.dataset.bound){dialog.dataset.bound='true';dialog.querySelector('[data-db-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});dialog.addEventListener('close',()=>{document.documentElement.style.overflow='';lastTrigger?.focus();});}
    document.querySelectorAll('[data-db-sort]').forEach(select=>{if(select.dataset.bound)return;select.dataset.bound='true';select.addEventListener('change',()=>{const grid=document.querySelector('[data-db-collection-grid]');if(!grid)return;const cards=[...grid.children];cards.sort((a,b)=>select.value==='price-ascending'?Number(a.dataset.price)-Number(b.dataset.price):select.value==='price-descending'?Number(b.dataset.price)-Number(a.dataset.price):Number(a.dataset.order)-Number(b.dataset.order));cards.forEach(card=>grid.append(card));});});
    document.querySelectorAll('.db-shop,.db-mobile').forEach(d=>{if(d.dataset.bound)return;d.dataset.bound='true';d.addEventListener('keydown',e=>{if(e.key==='Escape'){d.open=false;d.querySelector('summary').focus();}});});
  };
  document.addEventListener('DOMContentLoaded',init);document.addEventListener('shopify:section:load',init);init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {
  const boundAttribute = 'data-db-search-tap-bound';
  if (document.documentElement.hasAttribute(boundAttribute)) return;
  document.documentElement.setAttribute(boundAttribute, '');

  document.addEventListener('click', (event) => {
    if (!window.matchMedia('(max-width: 700px)').matches) return;
    const target = event.target instanceof Element ? event.target : null;
    if (!target || target.closest('button')) return;

    const galleryLink = target.closest('.db-search-product-card a[ref="cardGalleryLink"]');
    if (!galleryLink) return;

    const nextButton = galleryLink.querySelector('button[aria-label="Next slide"]');
    const slides = galleryLink.querySelectorAll('slideshow-slide');
    if (!nextButton || slides.length < 2) return;

    event.preventDefault();
    event.stopPropagation();
    nextButton.click();
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
